import { render } from "./rates.vue?vue&type=template&id=11f7d0fc"
import script from "./rates.vue?vue&type=script&lang=js"
export * from "./rates.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__